import React from 'react'
import OrderResume from '../components/OrderResume'
import PopupBg from '../components/PopupBg'

const CommndPopup = ({ closeModal, cart, transport, box }) => {
  return (
    <PopupBg opacity="transparent" closeModal={closeModal}>
            <div className="CommndPopup">
                <div className="container">
                    <OrderResume
                        cart={cart}
                        transport={transport}
                        box={box}
                    />
                </div>
            </div>
    </PopupBg>
  )
}

export default CommndPopup